import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BasicMoveListSetting, IBasicMoveListSetting, WorkListType } from 'shared/api/api';
import { SaveWorkListSetting } from 'shared/state/ducks/work-list-settings/operations';
import { localized } from 'shared/state/i18n/i18n';
import { WebAppState } from 'web/state/store.web';
import { TextWeb } from 'web/web-helpers/styled-text-components';
import { SkioldButton } from '../../skiold-components/skiold-button/skiold-button';
import { SkioldCheckbox } from '../../skiold-components/skiold-checkbox/skiold-checkbox';
import { SkioldFormsWrapper } from '../../skiold-components/skiold-forms-wrapper/skiold-forms-wrapper';
import { FormRow } from '../../skiold-components/skiold-forms-wrapper/skiold-forms-wrapper-types';
import { ViewWeb } from '../../utils/web-view';

interface Props {
	workListType: WorkListType;
}

export const BasicMoveListSetup: FC<Props> = React.memo(({ workListType }) => {
	const dispatch = useDispatch();
	// Setup from redux
	const listSetting = useSelector(
		(state: WebAppState) =>
			state.workListSettings.entities.find(wl => wl.type === workListType) as IBasicMoveListSetting,
	);
	const siteId = useSelector((state: WebAppState) => state.profile.active!.siteId);

	// Init setting
	const [basicMoveListSettings, setBasicMoveListSettings] = useState<IBasicMoveListSetting>(
		listSetting
			? listSetting
			: BasicMoveListSetting.fromJS({
					type: WorkListType.BasicMoveListSetting,
					siteId: siteId,
			  }),
	);
	const getHeader = (): FormRow => {
		return {
			header: localized(workListType),
		};
	};

	const toggleShowOnWeb = () => {
		setBasicMoveListSettings({
			...basicMoveListSettings,
			showOnWeb: !basicMoveListSettings.showOnWeb,
		} as IBasicMoveListSetting);
	};

	const toggleShowOnApp = () => {
		setBasicMoveListSettings({
			...basicMoveListSettings,
			showOnApp: !basicMoveListSettings.showOnApp,
		} as IBasicMoveListSetting);
	};


	const getAvailablityRow = (): FormRow => {
		return {
			name: localized('listAvailableOn'),
			component: (
				<ViewWeb className="work-list-helper-availability-row">
					<SkioldCheckbox onClick={toggleShowOnApp} isChecked={basicMoveListSettings.showOnApp!} />
					<TextWeb>{localized('App')}</TextWeb>
					<SkioldCheckbox onClick={toggleShowOnWeb} isChecked={basicMoveListSettings.showOnWeb!} />
					<TextWeb>{localized('Web')}</TextWeb>
				</ViewWeb>
			),
		};
	};


	const getFormRows = () => {
		let formRows = new Array<FormRow>();
		formRows.push(getHeader());
		formRows.push(getAvailablityRow());

		return formRows;
	};

	const save = () => {
		dispatch(SaveWorkListSetting(basicMoveListSettings));
	};

	const renderButtons = () => {
		return (
			<ViewWeb className="view-button-container">
				<SkioldButton title={localized('Save')} onPress={save} />
			</ViewWeb>
		);
	};

	return (
		<ViewWeb className="list-setup">
			<ViewWeb className="view-container">
				<TextWeb className="text-style">{localized('Setup')}</TextWeb>
				<SkioldFormsWrapper formRows={getFormRows()} containerClassName="wrapper-container" />
				{renderButtons()}
			</ViewWeb>
		</ViewWeb>
	);
});
